import {Component} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {EventItemType} from 'src/app/model/event-item-type';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  breadcrumbsContent: {
    name: string, params?: {
      [key: string]: string
    }
  }[] = [];
  urls: string[] = [];

  constructor(public translocoService: TranslocoService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.getPath(this.route);
    this.breadcrumbsContent = this.breadcrumbsContent.reverse();
    this.urls = this.urls.reverse();
  }

  getUrlIndex(breadcrumbIndex: number): number {
    return this.urls.length - (this.breadcrumbsContent.length - breadcrumbIndex) + 1;
  }

  navigateToBreadcrumbLink(itemIndex: number): void {
    if (itemIndex < this.urls.length - 1) {
      this.router.navigate(
        [...this.urls].slice(0, this.getUrlIndex(itemIndex)),
        {queryParams: this.breadcrumbsContent[itemIndex].params ?? undefined});
    }
  }

  getPath(route: ActivatedRoute | null): any {
    if (route === null) return;
    else {
      route.snapshot.url.reverse().map(segment => {
        if (segment.path) {
          this.urls.push(segment.path);
          if (segment.path === "private" || segment.path === "profile") {
            return;
          } else {
            this.breadcrumbsContent.push(this.getLabelAndParms(segment.path, route.snapshot.queryParams))
          }
        }
      });
      return this.getPath(route.parent);
    }
  };

  getLabelAndParms(segmentPath: string, queryParams: Params) {
    let paramsNames: string[] | undefined = this.paths[segmentPath]?.params;

    if (paramsNames) {
      let name: string = this.paths[segmentPath].label ?? "";
      let paramsMap = {};
      for (let param of paramsNames) {
        paramsMap = {...paramsMap, [param]: queryParams[param]}
        if (segmentPath === "userProfileDashboard" && param === "typeOfRace") {
          switch (queryParams[param]) {
            case EventItemType.MY_REGISTERED:
              name = "breadcrumbs.dashboard.races.my.registered";
              break;
            case EventItemType.MY_FINISHED:
              name = "breadcrumbs.dashboard.races.my.finished";
              break;
            case EventItemType.MY_FAVORITE:
              name = "page.header.favorites.races";
              break;
            default:
              break;
          }
        }
      }
      return {name: name, params: paramsMap};
    } else {
      return {name: this.paths[segmentPath].label};
    }
  }

  paths: { [name: string]: { label: string, params: string[] | undefined } } = {
    "finishedEvents": {label: "breadcrumbs.events.finished", params: undefined},
    "landing": {label: "breadcrumbs.events.landing", params: undefined},
    "leagues": {label: "page.header.series", params: undefined},
    "leagueDetails": {label: "breadcrumbs.series.details", params: ["leagueId"]},
    "eventDetails": {label: "breadcrumbs.events.details", params: ["typeOfRace", "eventId", "leagueId"]},
    "raceDetails": {label: "breadcrumbs.race.details", params: [ "eventId", "raceId", "leagueId"]},
    "eventCalendar": {label: "breadcrumbs.events.calendar", params: undefined},
    "userProfileDashboard": {label: "", params: ["typeOfRace", "eventId"]},
    "registerToRace": {label: "breadcrumbs.registerToRace", params: ["eventId", "raceId", "leagueId"]}
  }
}


